import { useLang } from "@/lib/i18n";
import { weekDays, dayHours, formatTime } from "@/lib/hours";

/** Every day of the week, with the day it is now marked. */
export default function HoursWeekList({ week }) {
  const { lang, t } = useLang();
  const today = (new Date().getDay() + 6) % 7;

  return (
    <div className="mt-3 border-t border-[#ededec]">
      {weekDays(lang).map((day, i) => {
        const hours = dayHours(week, day.key);
        const isToday = i === today;
        return (
          <div
            key={day.key}
            className="flex items-baseline justify-between gap-4 py-2 border-b border-[#ededec] last:border-b-0"
          >
            <div className={isToday ? "text-[13px] font-black text-[#171717]" : "text-[13px] text-[#6d6d6a]"}>
              {day.label}
              {isToday && (
                <span className="ml-1.5 font-mono text-[9px] tracking-[0.14em] uppercase text-[#8d8d88]">
                  {t("hours.today")}
                </span>
              )}
            </div>
            <div className={hours ? "text-[13px] font-bold text-[#171717]" : "text-[13px] text-[#8d8d88]"}>
              {hours ? `${formatTime(hours.open)}–${formatTime(hours.close)}` : t("hours.closedDay")}
            </div>
          </div>
        );
      })}
    </div>
  );
}